import React from "react";
import InternalLink from "components/InternalLink";
export default function LinkDetailsIcons({ ...props }) {
  if (!props.links) return null;

  let iconsize = props.iconsize ? props.iconsize : "sm";

  return (
    <div className="mdn-LinkDetails">
      {props.links.map(
        (
          {
            internal,
            icon,
            link,
            linkText,
            content,
            itemId,
            tabIndex,
            ...attributes
          },
          index
        ) => (
          <div
            key={index}
            className="mdn-LinkDetails-group"
            onMouseOver={props.onMouseOver}
            id={itemId}
          >
            <span
              onMouseLeave={props.onMouseLeave}
              onMouseOver={props.onMouseOver}
              className={`mdn-Icon-${icon} mdn-Icon--${iconsize} mdn-u-marginRight--xxs`}
              aria-hidden="true"
            ></span>
            <div>
              {internal ? (
                <InternalLink
                  {...attributes}
                  onMouseOver={props.onMouseOver}
                  className="mdn-Link mdn-Link-anchor cred-userMenuLink"
                  link={link}
                  id={itemId}
                >
                  {linkText}
                </InternalLink>
              ) : (
                <a
                  {...attributes}
                  onMouseOver={props.onMouseOver}
                  className="mdn-Link mdn-Link-anchor cred-userMenuLink"
                  href={link}
                  rel="noopener noreferrer"
                  id={itemId}
                  tabIndex={tabIndex}
                >
                  {linkText}
                </a>
              )}
              <p className="mdn-Text mdn-Text--body">{content}</p>
            </div>
          </div>
        )
      )}
    </div>
  );
}
